<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách Khách hàng tiềm năng</h1>
      <div class="float-right btn-group sm-float-none">
        <DraggableTable :naming="$route.name" v-model="fieldTable" @change="filterTable = $event" />
        <button
          type="button"
          class="font-medium f12 btn btn-outline-secondary"
          v-show="
            this.selected.length > 0 &&
            dataPermission &&
            dataPermission.includes('CNPS_CSTM_MERCHANT_UPDATE')
          "
          @click="openPopupDeploymentStaff()"
        >
          <span>&nbsp;</span>Gán NV triển khai
        </button>
        <button
          class="font-medium f12 btn btn-outline-secondary"
          @click="exportExcel()"
          v-if="dataPermission && dataPermission.includes('CNPS_CSTM_MERCHANT_EXPORT')"
        >
          <i class="bx bx-download"></i> Xuất file
        </button>
      </div>
    </div>
    <div class="p-10 card pt-15">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="submitForm">
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.textSearch"
              @keyup.enter="submitForm"
              class="form-control f12 hc-37 text-search"
              placeholder="Tên MC/Email/SĐT"
            />
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transformDate()"
              v-model="dateRange"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian tạo
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transformDate_2()"
              v-model="dateRangeConvert"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian chuyển đổi
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.regionId"
              :options="dataConfigRegion"
              @change="queryProvince($event)"
              placeholder="Vùng kinh doanh"
            />
          </div>

          <div class="form-group">
            <Select2
              v-model="search.cityCode"
              :options="dataProvince"
              placeholder="Tỉnh/Thành phố"
            />
          </div>

          <div class="form-group">
            <Select2 v-model="search.referSource" :options="sourceCreate" placeholder="Nguồn" />
          </div>

          <div class="form-group">
            <Select2 v-model="search.agentGroup" :options="dataAgentGroup" placeholder="Nhóm CTV" />
          </div>

          <div class="form-group">
            <Select2
              v-model="search.saleId"
              :options="listUser"
              placeholder="Nhân viên triển khai"
            />
          </div>

          <div class="form-group">
            <Select2
              v-model="search.teleSaleId"
              :options="listUser"
              placeholder="Nhân viên tư vấn"
            />
          </div>

          <div class="form-group">
            <Select2 v-model="search.mcc" :options="dataConfigMcc" placeholder="Ngành nghề" />
          </div>

          <div class="form-group">
            <Select2 v-model="search.rating" :options="dataRating" placeholder="Độ ưu tiên" />
          </div>

          <div class="form-group">
            <!-- <select2-multiple-control
              v-model="search.searchServiceList"
              :options="dataConfigService"
              placeholder="Dịch vụ quan tâm"
            /> -->
            <multiselect
              style="margin-top: -2px; font-size: 12px"
              v-model="serviceListChoose"
              :hide-selected="true"
              value="id"
              track-by="id"
              label="text"
              :multiple="true"
              :options="dataConfigService"
              :searchable="true"
              :close-on-select="false"
              :show-labels="false"
              :taggable="true"
              :limit="1"
              placeholder="Dịch vụ quan tâm"
            >
            </multiselect>
          </div>
          <div class="form-group form-group-action">
            <button
              @click="submitForm"
              class="pt-2 mr-2 btn btn-primary hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i>
              <span>&nbsp;</span>Lọc
            </button>

            <button
              type="button"
              @click="clearSearch"
              class="pt-2 mr-2 btn btn-outline-light hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
            >
              <i class="bx bx-filter-alt"></i>
              <span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div
            class="table-responsive"
            v-if="dataPermission && dataPermission.includes('CNPS_CSTM_MERCHANT_LIST')"
          >
            <div class="p-10">
              <div
                v-if="hasDefaultFilter"
                class="mb-2 d-inline-flex align-items-center"
                style="
                  background-color: #fff3e0;
                  padding: 6px 12px;
                  border-radius: 4px;
                  font-size: 13px;
                "
              >
                <i class="bx bx-info-circle mr-1" style="color: #f57c00"></i>
                <span style="color: #e65100">Đang lọc mặc định 3 ngày gần nhất</span>
                <button
                  @click="removeDefaultFilter"
                  type="button"
                  class="ml-2 btn-close-filter"
                  style="
                    background: none;
                    border: none;
                    cursor: pointer;
                    padding: 0 4px;
                    color: #e65100;
                    font-size: 16px;
                    line-height: 1;
                  "
                  title="Bỏ lọc"
                >
                  ×
                </button>
              </div>
              Tổng khách hàng:
              <strong class="text-primary">{{ pagination?.total?.toLocaleString('vi-VN') }}</strong>
              <b-table
                :busy.sync="loading"
                hover
                sticky-header
                responsive
                :items="dataMerchant"
                :fields="filterTable"
                :fixed="true"
                :bordered="true"
              >
                <template #table-busy>
                  <div class="my-2 text-center">
                    <b-spinner class="align-middle"></b-spinner>
                  </div>
                </template>
                <template #head(selected)>
                  <b-form-checkbox v-model="selectAll"></b-form-checkbox>
                </template>
                <template #cell(selected)="data">
                  <b-form-checkbox
                    v-model="selected"
                    :value="data.item.customerId ? data.item.customerId : ''"
                    @change="checkSelectedItem(data.item.customerId)"
                  />
                </template>
                <template #cell(info)="data">
                  {{ data.item.merchantName }}<br />
                  {{ data.item.mobile | encryptPhone }}
                  <a href="#" v-if="!(data.item.accIdType && data.item.accIdType === 'MOBILE')">{{
                    data.item.email
                  }}</a>
                  <div v-if="data.item.score">
                    <span class="bage badge-pill rateLead" v-if="data.item.tag"
                      >{{ data.item.tag | transformData(Config.tagLead) }}:
                      {{ data.item.score }}</span
                    >
                  </div>
                </template>
                <template #cell(address)="data">
                  {{ data.item.address + ', ' + data.item.district + ', ' + data.item.city }}
                </template>
                <template #cell(mcc)="data">
                  {{ data.item.mcc | transfromMccName(dataConfigMcc) }}
                </template>
                <template #cell(rating)="data">
                  {{ data.item.rating ? data.item.rating : '' | transformData(dataRating) }}
                </template>
                <template #cell(service)="data">
                  <div v-for="(itemm, indexx) in data.item.listServiceType" :key="indexx">
                    <span v-if="itemm.serviceType !== '0'">{{
                      itemm.serviceType | serviceTypes
                    }}</span>
                  </div>
                </template>
                <template #cell(referSource)="data">
                  {{
                    data.item.referSource ? data.item.referSource : '' | transformData(sourceCreate)
                  }}
                </template>
                <template #cell(agentGroup)="data">
                  {{
                    data.item.agentGroup ? data.item.agentGroup : '' | transformData(dataAgentGroup)
                  }}
                </template>
                <template #cell(sale)="data">
                  <div v-if="data.item.activeSaleName">
                    <b>Nhân viên triển khai: </b>
                    <p>{{ data.item.activeSaleName }}</p>
                    <p>{{ data.item.activeSaleEmail }}</p>
                  </div>
                  <br />
                  <div v-if="data.item.teleSaleName">
                    <b>Nhân viên tư vấn: </b>
                    <p>{{ data.item.teleSaleName }}</p>
                    <p>{{ data.item.teleSaleEmail }}</p>
                  </div>
                </template>
                <template #cell(createAt)="data">
                  <p class="text-nowrap">
                    <b>Tạo: </b> {{ data.item.createAt | formatHour1 }},
                    {{ data.item.createAt | formatDate1 }}
                  </p>
                  <p class="text-nowrap">
                    <b>Cập nhật: </b> {{ data.item.modifiedAt | formatHour1 }},
                    {{ data.item.modifiedAt | formatDate1 }}
                  </p>
                  <p class="text-nowrap">
                    <b>Chuyển đổi: </b> {{ data.item.verifyDate | formatHour1 }},
                    {{ data.item.verifyDate | formatDate1 }}
                  </p>
                  <p class="text-nowrap">
                    <b>Tư vấn cuối: </b> {{ data.item.lastCareDate | formatHour1 }},
                    {{ data.item.lastCareDate | formatDate1 }}
                  </p>
                </template>
                <template #cell(action)="data">
                  <b-dropdown class="text-center" variant="outline-light">
                    <b-dropdown-item
                      class="dropdown-item"
                      v-if="dataPermission && dataPermission.includes('CNPS_CSTM_MERCHANT_DETAIL')"
                      @click="detailPotentialCustomer(data.item)"
                      ><i class="bx bx-detail"></i><span>&nbsp;</span>Chi tiết
                    </b-dropdown-item>
                    <b-dropdown-item
                      v-if="
                        callioConfig.active === true || dataUser.username === 'haopv@yopmail.com'
                      "
                      class="dropdown-item"
                      @click="setCurrentUserCall(data.item)"
                      ><i class="bx bx-phone"></i><span>&nbsp;</span>Gọi điện
                    </b-dropdown-item>
                    <b-dropdown-item
                      class="dropdown-item"
                      v-if="dataPermission && dataPermission.includes('CNPS_CSTM_MERCHANT_UPDATE')"
                      @click="editPotentialCustomer(data.item)"
                      ><i class="bx bx-edit-alt"></i><span>&nbsp;</span>Sửa
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--Modal thông báo-->
    <b-modal id="modal-scoped" centered v-model="notiModal">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <img :src="iconNoti" :alt="iconNoti" />
        <h2 class="py-3 f18">{{ msgNoti }}</h2>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="light" @click="cancel()"> Đóng </b-button>
      </template>
    </b-modal>

    <developmentStaff
      ref="developStaff"
      :showListStaff="showListStaff"
      @submit="assignSelectedStaff"
      @close="showListStaff = false"
    >
    </developmentStaff>

    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>

    <div class="pagination-bottom">
      <b-pagination
        v-model="search.page"
        :total-rows="pagination.total"
        :per-page="search.limit"
        class="mr-2 fl-right"
      ></b-pagination>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import { StaffService } from '@/services/staff.service'
  import { MerchantService } from '@/services/merchant.service'
  import { MerchantPotentialService } from '@/services/merchantPotential.service'
  import { CommonService } from '@/services/common.service'

  import Config from '../../thirdParty/config'
  import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
  import DateRangePicker from 'vue2-daterange-picker'
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
  import moment from 'moment'
  import { AgentService } from '@/services/agent.service'
  import { SalesManagerService } from '@/services/sales-manager.service'
  import developmentStaff from './AssignModal/developmentStaff.vue'
  import { getLastNDays } from '@/utils/util'

  const fieldTable = [
    { key: 'selected' },
    { key: 'info', label: 'Thông tin KH' },
    { key: 'address', label: 'Địa chỉ' },
    { key: 'mcc', label: 'Ngành nghề' },
    { key: 'rating', label: 'Độ ưu tiên' },
    { key: 'service', label: 'Dịch vụ quan tâm' },
    { key: 'referSource', label: 'Nguồn tạo' },
    { key: 'agentGroup', label: 'Nhóm CTV' },
    { key: 'sale', label: 'Nhân viên triển khai/Nhân viên tư vấn' },
    { key: 'createAt', label: 'Thời gian tạo' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]
  export default {
    components: {
      DateRangePicker,
      developmentStaff,
    },
    data() {
      const { from, to } = getLastNDays(3, 'date')
      return {
        Config,
        loading: true,
        fieldTable,
        filterTable: fieldTable,
        selected: [],
        dataUser: JSON.parse(localStorage.getItem('userData')),
        callioConfig: JSON.parse(localStorage.getItem('callioConfig')) ?? {},
        listAfterSale: Config.listAfterSale,
        dataMerchant: [],
        dataProvince: [],
        optionsStaff: [],
        listUser: [],
        listCTV: [],
        listState: Config.listStatusMC,
        listStateSearch: [],
        listPriod: [],
        sourceCreate: Config.sourceCreate,
        dataConfigRegion: [],
        search: {
          limit: 50,
          page: 1,
        },
        pagination: {
          total: 0,
        },
        optionRule: [
          { text: 'Chưa xử lý', id: 0 },
          { text: 'Đã xử lý', id: 1 },
        ],
        dataConfigService: [],
        dataConfigMcc: [],
        localeData: Config.localeData,
        dateRange: {
          startDate: from,
          endDate: to,
        },
        dateRangeConvert: {
          startDate: null,
          endDate: null,
        },
        stateSelected: '',
        notiModal: false,
        iconNoti: '',
        msgNoti: '',
        dataRating: [
          { id: '0', text: 'Tất cả' },
          { id: 'HOT', text: 'Ưu tiên' },
          { id: 'WARM', text: 'Thường' },
          { id: 'COLD', text: 'Không ưu tiên' },
        ],
        serviceListChoose: null,
        showListStaff: false,
        selectedStaff: null,
        showLoading: false,
        dataSale: [],
        dataAgentGroup: Config.dataAgentGroup,
        checkSelectAll: false,
        hasDefaultFilter: true,
      }
    },

    mixins: [prepareQueryParamsMixin],

    filters: {
      // lấy giờ tạo
      formatHour1(date) {
        if (date) return date.substring(10, 16)
      },
      // lấy ngày tạo
      formatDate1(date) {
        if (date) return date.substring(0, 10)
      },
      transfromMccName(data, dataConfigMcc) {
        const dataReturn = dataConfigMcc.filter(e => e.id === data)
        if (dataReturn.length === 0) {
          return ''
        }
        return dataReturn[0].text
      },
      transfromRegion(data, dataConfigRegion) {
        const dataReturn = dataConfigRegion.filter(e => e.id === data)
        if (dataReturn.length === 0) {
          return ''
        }
        return dataReturn[0].text
      },
      serviceTypes(itemm) {
        const listServiceTypes = Config.listServiceTypes
        return listServiceTypes[itemm] ? listServiceTypes[itemm] : itemm
      },
    },

    created() {
      this.transformDate()
      this.fetchData()
      this.getListStaffBySuperior()
      this.getRegions()
      this.configSystem()
      this.getListCTV()
    },

    computed: {
      useInUrlQueryPropList() {
        return this.prepareQueryParamsMixin({
          size: this.search.size,
          page: this.search.page,
        })
      },
      ...mapGetters({
        dataPermission: 'role/dataPermission',
        dataSearch: 'search/getDataSearchOther',
      }),
      selectAll: {
        get: function () {
          return this.dataMerchant ? this.selected.length === this.dataMerchant.length : false
        },
        set: function (value) {
          var selected = []
          if (value) {
            this.dataMerchant.forEach(function (item) {
              selected.push(item.customerId)
            })
            this.checkSelectAll = true
          }
          this.selected = selected
        },
      },
    },
    watch: {
      'search.page': function () {
        this.$router.replace({
          query: this.useInUrlQueryPropList,
        })
        this.fetchData()
      },
    },

    methods: {
      // gọi điện
      setCurrentUserCall(data) {
        this.$store.commit('callio/SET_TMP_CURRENT_USER_CALL', {
          customerId: data.customerId,
          customerName: data.customerName,
          mobile: data.mobile,
          email: data.email,
          city: data.city,
          district: data.district,
          merchantType: data.merchantType,
        })
        this.$store.commit('callio/SET_MODAL', true)
        this.$store.commit('callio/SET_MODAL_MINI', false)
      },
      // chuyển trang chi tiết
      detailPotentialCustomer(item) {
        window.open(`/detail-potential-customers/${item.customerId}`)
      },
      // chuyển trang sửa
      editPotentialCustomer(item) {
        this.$router.push({ path: `/edit-potential-customers/${item.customerId}` })
      },
      // thêm mc mới
      merchantAdd() {
        this.$router.push('/merchant-add')
      },
      // nút lọc
      async submitForm(event) {
        event.preventDefault()
        this.pagination.page = 1
        this.fetchData()

        this.$store.commit('search/SET_DATA_SEARCH_OTHER', {
          data: this.search,
          router: this.$router.currentRoute.path,
        })
      },
      // nút bỏ lọc
      async clearSearch() {
        this.search = {
          limit: 50,
          page: 1,
        }
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        this.dateRangeConvert = {
          startDate: null,
          endDate: null,
        }
        this.dataProvince = []
        this.serviceListChoose = []
        this.hasDefaultFilter = false
        await this.fetchData()
      },
      // Bỏ lọc mặc định
      removeDefaultFilter() {
        this.search = {
          limit: 50,
          page: 1,
        }
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        this.dateRangeConvert = {
          startDate: null,
          endDate: null,
        }
        this.dataProvince = []
        this.serviceListChoose = []
        this.hasDefaultFilter = false
        this.fetchData()
      },
      // xuất Excel
      async exportExcel() {
        try {
          this.showLoading = true
          this.search.userId = this.dataUser.userId
          this.search.searchServiceList = this.serviceListChoose
            ? this.serviceListChoose.map(e => e.id)
            : []
          if (this.search.searchServiceList.length === 0) delete this.search.searchServiceList

          this.search.status = 'CURRENT_CONSULTING'

          for (const key in this.search) {
            if (this.search[key] === '0') delete this.search[key]
          }

          if (this.search.regionId) {
            const data = this.dataConfigRegion.filter(e => {
              return this.search.regionId === e.id
            })
            this.search.regionName = data[0].text
          }
          await MerchantPotentialService.exportExcelPotentialCustomer(this.search)
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      // lấy vùng
      async getRegions() {
        const data = await StaffService.getRegions()
        if (data.data.length > 0) {
          this.dataConfigRegion.push({ id: 0, text: 'Tất cả' })
          data.data.map(e => {
            this.dataConfigRegion.push({ id: e.id, text: e.name })
          })
        }
      },
      // lấy tỉnh, tp
      async queryProvince(e) {
        try {
          // this.search.cityCode = '0'
          const data = await StaffService.getProvinceRegion({ regionId: [e] })
          if (data.data.length > 0) {
            const dataProvince = [{ id: 0, text: 'Tất cả' }]
            data.data.map(e => {
              dataProvince.push({ id: e.code, text: e.name })
            })
            this.dataProvince = dataProvince
          }
        } catch (error) {}
      },
      // Lấy danh sách nhân viên
      async getListStaffBySuperior() {
        try {
          const data = await StaffService.getStaffByIdSuperior({
            userId: this.dataUser.userId,
          })
          if (data.data.length > 0) {
            this.listUser.push({ id: 0, text: 'Tất cả' })
            data.data.map(e =>
              this.listUser.push({ id: e.userId, text: `${e.name} - ${e.userName}` })
            )
            return
          }
          this.listUser = []
        } catch (error) {
          console.log(error)
        }
      },
      // lấy ngành hàng và dịch vụ
      configSystem() {
        return CommonService.getConfigSystem()
          .then(data => {
            if (data.success) {
              // this.dataConfigService.push({ id: 0, text: 'Tất cả' })
              data.data.services.map(e => this.dataConfigService.push({ id: e.code, text: e.name }))
              this.getListService()
              this.dataConfigMcc.push({ id: 0, text: 'Tất cả' })
              data.data.businessFields.map(e =>
                this.dataConfigMcc.push({ id: e.code, text: e.name })
              )
            }
          })
          .catch(error => console.log(error))
      },
      async getListService() {
        try {
          const response = await SalesManagerService.getGroupService({})
          if (response.code === 1000) {
            this.dataGroupService = response.data.groupService
            const data = this.dataGroupService.filter(e => e.service === 'SELL')
            if (data[0].detail.length > 0) {
              data[0].detail.map(e => {
                const body = {
                  id: e.code,
                  text: this.serviceTypes(e.name),
                }
                this.dataConfigService.push(body)
              })
            }
            // ListState
            this.listStateSearch = [{ id: 0, text: 'Tất cả' }, ...this.listState]
          }
        } catch (error) {
          console.log(error, '=========>')
        }
      },
      serviceTypes(itemm) {
        const listServiceTypes = Config.listServiceTypes
        return listServiceTypes[itemm] ? listServiceTypes[itemm] : itemm
      },
      // dữ liệu bảng
      async fetchData() {
        try {
          this.loading = true
          this.search.userId = this.dataUser.userId

          this.search.status = ['CURRENT_CONSULTING']
          this.search.isExpireCurrentConsulting = true

          this.search.searchServiceList = this.serviceListChoose
            ? this.serviceListChoose.map(e => e.id)
            : []
          if (this.search.searchServiceList.length === 0) delete this.search.searchServiceList

          for (const key in this.search) {
            if (this.search[key] === '0') delete this.search[key]
          }

          const data = await MerchantService.getDataMerchantPotential(this.search)
          if (data.success) {
            this.dataMerchant = data.data
            this.pagination.total = data.meta.pagination.total ? data.meta.pagination.total : 0
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.selected = []
          this.loading = false
        }
      },

      transformDate() {
        this.search.startDate = moment(this.dateRange.startDate)
          .startOf('day')
          .add(7, 'hours')
          .valueOf()
        this.search.endDate = moment(this.dateRange.endDate).endOf('day').add(7, 'hours').valueOf()
      },
      transformDate_2() {
        this.search.startVerifyDate = moment(this.dateRangeConvert.startDate)
          .startOf('day')
          .add(7, 'hours')
          .valueOf()
        this.search.endVerifyDate = moment(this.dateRangeConvert.endDate)
          .endOf('day')
          .add(7, 'hours')
          .valueOf()
      },
      async getListCTV() {
        try {
          const dataItem = await AgentService.listAgentByUser({
            userId: this.dataUser.userId,
          })
          if (dataItem.success) {
            this.listCTV = [{ id: 0, text: 'Tất cả' }]
            dataItem.data.map(e => {
              this.listCTV.push({ id: e.agentId, text: e.name })
            })
          }
        } catch (error) {
          console.log(error)
        }
      },

      openPopupDeploymentStaff() {
        this.showListStaff = true
      },

      async assignSelectedStaff(data) {
        this.selectedStaff = data.userId.length > 0 ? data.userId[0] : ''
        this.dataSale = data.dataSale
        this.showListStaff = false
        this.showLoading = true
        await this.assignDeploymentStaff()
      },

      async assignDeploymentStaff() {
        try {
          const response = await MerchantPotentialService.assignDeploymentStaff({
            customerIds: this.selected,
            saleId: this.selectedStaff,
          })
          if (response.code === 1000) {
            this.notiModal = true
            this.iconNoti = require('@/assets/img/noti-success2.svg')
            this.msgNoti = `Gán ${this.selected.length} khách hàng tiềm năng cho ${this.dataSale[0].name} thành công`
            await this.fetchData()
            setTimeout(() => {
              this.notiModal = false
            }, 1500)
          } else {
            this.showErr(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },

      showErr(message) {
        this.notiModal = true
        this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
        this.msgNoti = message
      },

      checkSelectedItem(customerId) {
        if (this.checkSelectAll && this.selected.length === 0) {
          const selected = []
          this.dataMerchant.forEach(item => {
            if (item.customerId !== customerId) selected.push(item.customerId)
          })
          this.selected = selected
        }
        if (this.selected.length !== 0) this.checkSelectAll = false
      },
    },
  }
</script>

<style scoped>
  .time-placeholder,
  .text-search::placeholder {
    color: #999 !important;
  }
  .column-responsive {
    max-width: 10rem;
  }
  .multiselect::-webkit-input-placeholder::before {
    content: 'placeholder';
  }
</style>

<style>
  .multiselect__tag,
  .multiselect__strong {
    font-size: 10px !important;
  }
  .multiselect {
    border: 1px solid #ced4da !important;
    border-radius: 4px !important;
  }
  .multiselect__tags {
    font-size: 12px !important;
  }
  .multiselect__option--highlight {
    border-color: #5897fb !important;
    background-color: #5897fb !important;
  }
  .multiselect__tag {
    background: #5897fb !important;
  }
  .multiselect__tag-icon:hover {
    background: #5897fb !important;
  }
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
